// IMPORTANTE: Este componente define a logo oficial do Bolão Elite.
// logo.svg    → logo completa com texto "Bolão Elite" embutido (showText=true)
// favicon.svg → ícone sem texto, quadrado, fundo transparente (showText=false)

interface LogoProps {
  size?: 'sm' | 'md' | 'lg' | 'xl' | '2xl';
  showText?: boolean;
  className?: string;
  /** Sobrescreve as classes da <img> diretamente (suporta classes responsivas do Tailwind) */
  imgClassName?: string;
}

// Altura da logo completa (logo.svg é retangular, largura automática)
const logoHeightConfig = {
  sm: 'h-7',
  md: 'h-9',
  lg: 'h-12',
  xl: 'h-20',
  '2xl': 'h-[350px]',
};

// Tamanho do ícone quadrado (favicon.svg)
const iconSizeConfig = {
  sm: 'w-8 h-8',
  md: 'w-10 h-10',
  lg: 'w-14 h-14',
  xl: 'w-20 h-20',
  '2xl': 'w-[440px] h-[350px]',
};

export function Logo({ size = 'md', showText = true, className = '', imgClassName }: LogoProps) {
  if (showText) {
    return (
      <div className={`flex items-center ${className}`}>
        <img
          src="/logo.svg"
          alt="Bolão Elite"
          className={imgClassName ?? `${logoHeightConfig[size]} w-auto object-contain`}
        />
      </div>
    );
  }

  return (
    <div className={`flex items-center ${className}`}>
      <img
        src="/favicon.svg"
        alt="Bolão Elite"
        className={imgClassName ?? `${iconSizeConfig[size]} object-contain`}
      />
    </div>
  );
}
